import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop({ routesToScroll = [] }) { // Accepts an array of routes
  const { pathname } = useLocation();

  useEffect(() => {
    // Check if the current pathname (or a part of it) is in the list of routes to scroll
    const shouldScroll = routesToScroll.some(route => pathname.startsWith(route));

    if (shouldScroll) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    }
  }, [pathname, routesToScroll]); // Re-run if pathname or routesToScroll changes

  return null;
}

export default ScrollToTop;